import * as React from "react";
import { forwardRef, memo } from "react";
const SvgKw = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 2, fill: "#007a3d" }), /* @__PURE__ */ React.createElement("rect", { width: 12, height: 2, y: 2, fill: "#fff" }), /* @__PURE__ */ React.createElement("rect", { width: 12, height: 2, y: 4, fill: "#ce1126" }), /* @__PURE__ */ React.createElement("polygon", { points: "0,0 3,2 3,4 0,6" }));
const ForwardRef = forwardRef(SvgKw);
const Memo = memo(ForwardRef);
export default Memo;
